import React from 'react'
import { TheCard, ProfileInfoCon, ProfileName, ProfileTitle, ProfileMessage } from './ProfileCard.styled'

const ProfileCard = ({ name, title, besked }) => {
    return (
        <TheCard>
            <ProfileInfoCon>
                <ProfileName>
                    {name}
                </ProfileName>
                <ProfileTitle>
                    {title}
                </ProfileTitle>
                <ProfileMessage>
                    {besked}
                </ProfileMessage>
            </ProfileInfoCon>
        </TheCard>
    )
}

export default ProfileCard